import React, { useState, useRef } from "react";
import styles from "./country-card.module.scss";
import CardHeader from "../common/cardHeader/CardHeader";
import ProgressBar from "../common/progressbar/ProgressBar";
import Icon from "../common/svg-icon/icon";
import EmptyCard from "../common/emptyCard/EmptyCard";
import Select, { components, createFilter } from "react-select";
// import {
//     calculatePortfolioOverview
// } from "../../utilities/calculator";
import { getCountryISO2 } from "../../utilities/converter";
import { flag, formatNumberWithDot } from "../../utilities/utils";

const CountryCard = ({
  cardType,
  emptyText,
  minHeight,
  optionList,
  onSelectChange,
  selectedValue,
  onClickToPosition,
  onClearClick,
}) => {

  // console.log(selectedValue);
  // console.log(cardType);
  const [show, setShow] = useState(false);
  const [focused, setFocused] = useState(false);
  // const [menuOpen, setMenuOpen] = useState(false);

  const elementClass = cardType === "Passport" ? "col-lg-6" : "";
  // const data = selectedValue ? calculatePortfolioOverview({iso_code: selectedValue.iso_code, type:selectedValue.type}): null;
  const data = selectedValue ? selectedValue.countryData: null;
  const freeVisaCountries = selectedValue ? selectedValue.freeVisaCountries: null;
  const minimumInvestmentUSD = data ? data.minimumInvestmentUSD : null;
  const addText = cardType === "Passport" ? "Add your passport" : "Add program";
  const changeText = cardType === "Passport" ? "Change passport" : "Change program";
  const selectRef = useRef();


  const selectStyles = {
      menu: (provided) => ({
        ...provided,
        position:'relative',
        border:0,
        boxShadow:'none',
        marginTop:0,
        marginBottom:0,
      }),
      menuList:(provided) => ({
        ...provided,
        paddingTop:0,
        paddingBottom:0,
        background:"#f7f7f7",
      }),
      control: (provided) => ({
        ...provided,
        background: "#f7f7f7",
        border: "1px solid #405363",
        boxShadow: "none",
        borderRadius: 0,
        height:36,
        minHeight:36,
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        display:'none',
      }),
      placeholder: (provided) => ({
        ...provided,
        fontFamily: "Roboto Regular",
        fontSize: 12 ,
        lineHeight: 14,
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
      }),
      singleValue: (provided) => ({
        ...provided,
        color: "#405363",
        fontFamily: "Roboto Regular",
        fontSize: 12,
        lineHeight: 14,
      }),
      valueContainer: (provided) => ({
        ...provided,
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        background: "#f7f7f7",
      }),
      option: (provided, state) => ({
        ...provided,
        fontSize: 12,
        padding: 4,
        backgroundColor: state.isFocused
          ? "#C1C5C8"
          : state.isSelected
          ? "#405363"
          : null,
        color: state.isFocused
          ? "#405363"
          : state.isSelected
          ? "#fff"
          : "#405363",
      }),
    };
  
  const { Option, Control } = components;
  const IconOption = (props) => {
      
        const flagName = getCountryISO2(props.data.iso_code);
        const flagUrl = flag(flagName);
        const optionTypeText = props.data.type === 'rpi' ? 'Residence' : '';

        return(
          <Option {...props}>
              <div className={styles.optionContent}>
                <img src={flagUrl} style={{ height: '24px', width: '24px', borderRadius: '50%', marginRight: '10px', border:'1px solid #C1C5C8' }} alt={props.data.label} />
                <span className={styles.optionText}>{props.data.label} {optionTypeText}</span>
              </div>
          </Option>
        );
  };

  const CustomControl = ({children, ...props}) => {
        return(
          <div>
            <Control {...props}>
                <span className={styles.inputSearchIcon}><Icon name="search" /></span>
                {children}
            </Control>
            {!focused && <span className={styles.focusedLayer} onClick={onFocusClick}></span>}
            {selectedValue !== '' && <span className={styles.clear} onClick={onClear}>CLEAR</span>}
          </div>
        );
  };

  const filterConfig = {
      ignoreCase: true,
      trim: true,
      matchFrom: 'start'
  }


  const dropdown = () => {
    return (
        <Select
            className={styles.countrySelect}
            options={optionList}
            placeholder="Search countries"
            onChange={onChange}
            value={selectedValue}
            isSearchable={true}
            // isClearable={true}
            components={{Option: IconOption, Control: CustomControl}}
            blurInputOnSelect={true}
            openMenuOnFocus={true}
            maxMenuHeight={160}
            // onBlur={(event)=>onBlur(event)}
            onFocus={onFocus}
            styles={selectStyles}
            // defaultMenuIsOpen={true}
            ref={selectRef}
            filterOption={createFilter(filterConfig)}
        />
    );
  };

  const minimumInvestment = () =>{
    if( cardType !== 'Passport'){
      return (
        <div className={styles.minimumInvestment}>
          <strong>Approx. Minimum Investment</strong><br />
          USD <strong>{minimumInvestmentUSD ? formatNumberWithDot(minimumInvestmentUSD) : 0}</strong>
        </div>
      );
    }
  
  }

  const onFocusClick = () =>{
    selectRef.current.focus();
  }

  const onClear = () =>{
    setShow(false);
    onClearClick();
  }


  const showDropdown = () => {
    setShow(true);
  };

  const onChange = (option) =>{
    // console.log(option);
    onSelectChange(option);
    setShow(false);
    setFocused(false);
  }


  const onFocus = () =>{
    // console.log(selectRef.current.select);
    setFocused(true);
    // selectRef.select.focus();
  }


  return (
    <>
      <div
        className={`${styles.card} ${data ? styles.cardWithContent : ''} ${show ? styles.showCountrySelection : ''}  ${focused ? styles.showCountrySelectionFull : ''} d-flex flex-column`}
        style={{ minHeight: minHeight }}>
        {data && (
          <>
          
            <CardHeader
              countryCode={getCountryISO2(selectedValue.iso_code)}
              countryName={data.country}
              showPassport={cardType === 'Passport'}
              showCBI={cardType === 'cpi'}
              showCBN={cardType === 'cbn'}
              showRBI={cardType === 'rpi'}
              visaFreeDestinations={freeVisaCountries}
            />

            <div className={`${styles.cardBody} ${cardType !== 'Passport' ? "pt-0" : ""}`}>
              {minimumInvestment()}

              <div className="mb20"><strong>Scores for key benefits </strong>(out of 100)</div>

              <div className="row">
                

                <div className={`col-12 mb10 ${elementClass}`}>
                  <ProgressBar name="Business Opportunity" value={data.businessOpportunity} />
                </div>
                <div className={`col-12 mb10 ${elementClass}`}>
                  <ProgressBar name="Climate Resilience" value={data.climateResilience} />
                </div>
                <div className={`col-12 mb10 ${elementClass}`}>
                  <ProgressBar name="Economic Mobility" value={data.economicMobility} />
                </div>
                <div className={`col-12 mb10 ${elementClass}`}>
                  <ProgressBar name="Premium Education" value={data.education} />
                </div>
                <div className={`col-12 mb10 ${elementClass}`}>
                  <ProgressBar name="Quality of Life" value={data.lifestyle} />
                </div>
                <div className={`col-12 mb10 ${elementClass}`}>
                  <ProgressBar name="Private Healthcare" value={data.privateHealthcare} />
                </div>
                <div className={`col-12 mb10 ${elementClass}`}>
                  <ProgressBar name="Safety and Security" value={data.safetyAndSecurity} />
                </div>
              </div>
            </div>

            <div className={styles.total}>
              <div className="row justify-content-between align-items-center">
                <div className="col">
                  <strong>Total Country Score</strong> <small>(out of 700)</small>
                </div>
                <div className="col-auto">
                  <strong>{data.overall}</strong>
                </div>
              </div>
            </div>

            <div className={`${styles.countryBar}`} >
              <div className={`row justify-content-between align-items-center ${styles.countrySelectToggle}`}>
                <div className="col">{changeText}</div>
                <div className="col-auto">
                  {!show ?
                  (<div className={`${styles.icon} ${styles.icon20}`} onClick={showDropdown}>
                    <Icon name="plus" />
                  </div>)
                  :(<div className={`${styles.icon} ${styles.icon16}`} onClick={()=>setShow(false)}>
                    <Icon name="close" />
                  </div>)
                  }
                </div>
              </div>
              {show ? dropdown() : ''}
            </div>
          </>
        )}
        {!data && (
          <>
            <EmptyCard text={emptyText} onClick={showDropdown} />
            {show && 
      
              <div className={styles.countryBar}>
                  <div className={`row justify-content-between align-items-center ${styles.countrySelectToggle}`}>
                    <div className="col">{addText}</div>
                    <div className="col-auto">
                      {!show ?
                        (<div className={`${styles.icon} ${styles.icon20}`} onClick={showDropdown}>
                          <Icon name="plus" />
                        </div>)
                        :(<div className={`${styles.icon} ${styles.icon16}`} onClick={()=>setShow(false)}>
                          <Icon name="close" />
                        </div>)
                      }
                    </div>
                  </div>
                  {dropdown()}
              </div>
            }
          </>
        )}
      </div>
      {data && 
        <div onClick={onClickToPosition} className={styles.viewSummaryButton}>
          View Summary
          <span className={`${styles.icon} ${styles.icon16}`}>
            <Icon name="arrow-up" />
          </span>
        </div>
      }
    </>
  );
};

export default CountryCard;
